
import { AddFolder } from "iconoir-react";
import React, { useReducer } from "react";
import Swal from "sweetalert2";
import { domain } from "../../../../Urls/Services/Api_urls";

export const OrderEmp = (props) => {
  const allowedStatus = new Set(["Recibida"]);
  const tableMeta = props.tableMeta;

  const [groups, setGroups] = React.useState(null);
    const [token, setToken] = React.useState(null);
  
    React.useEffect(() => {
      setGroups(window.sessionStorage.getItem("groups"));
      setToken(window.sessionStorage.getItem("token"));
    }, []);

  if (allowedStatus.has(tableMeta.is_actived)) {
    return (
      <>
        <button
        className="p-1 cursor-pointer bg-orange-500 hover:bg-orange-600 text-white rounded-md"
        title="Empaquetar"
          onClick={() => {
            var myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${token}`);
            myHeaders.append("Content-Type", "application/json");

            const ide = tableMeta.id;
            

            var requestOptions = {
              method: "POST",
              headers: myHeaders,

              redirect: "follow",
            };

            Swal.fire({
              title: "Empaquetar",
              text: tableMeta.cc,
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Si, Empaquetar",
              cancelButtonText: "No",
            }).then((result) => {
              if (result.isConfirmed) {
                fetch(
                  domain + "/portal/" + ide + "/packageContract/",
                  requestOptions
                ).then(async function (response) {
                  console.log(response);
                  if (response.status === 200) {
                    Swal.fire(
                      "Solicitud registrada correctamente",
                      "Verifica tu cuenta en el correo",
                      "success"
                    );
                  } else {
                    if (response.status === 400) {
                      try {
                          const { msg = {} } = await response.json();
                          const errors = typeof msg === 'string' ? { error: msg } : msg;
                          
                          Swal.fire({
                              icon: "error",
                              title: "Error",
                              html: `
                                  <div>
                                      ${Object.entries(errors).map(([field, error]) => `
                                          <div><b>${field}:</b> ${Array.isArray(error) ? error.join('<br>') : error}</div>
                                      `).join('')}
                                  </div>
                              `,
                          });
                      } catch (error) {
                          console.error('Error parsing JSON:', error);
                          Swal.fire({
                              icon: "error",
                              title: "Error",
                              text: "Ocurrió un error inesperado.",
                          });
                      }
                    }
                  }
                });
              }
            });
          }}
        >
          <AddFolder
           
          />
        </button>
      </>
    );
  } else return null;

};
